export const PENSION = {
  nickname: 'PRODUCTS.PENSION.nickname',
  icon:'pension'
};
